import {
  appEventKey
} from '@/config/index';
import { Dialog } from 'vant'
import store from '@/store/index';
export default {
  sendAppMsg(config = {}) {
    const {
      event,
      params,
      callback
    } = config
    this.registerEvent(event, callback)
    const {
      uni
    } = window
    if (!uni) {
      console.error('未正确加载uni-webview.js')
    }

    const data = {
      event,
      params: params || {}
    }

    uni.postMessage({
      data
    })
  },
  registerEvent(eventName, event) {
    // 在window下注册事件，供app调用
    if (!event || !eventName) return

    window[appEventKey] = window[appEventKey] || {}
    window[appEventKey][eventName] = event || window[appEventKey][eventName]
  },
  openUrl(url) {
    // 打开外部链接
    if (!url) return

    const params = { config: { url } }
    const config = {
      event: 'openOuterUrl',
      params
    }

    this.sendAppMsg(config)
  },
  appVersionCompare(targetVersion) {
    // 使用app当前版本与指定版本作对比，返回对比结果：
    // -1为当前版本小于指定版本，0为相等，1为大于
    // 一般用于调用方法时，避免旧版的app安装包无法调用新版的功能导致功能报错
    const { appWgtVersion } = store.state.appInfo
    const parts1 = appWgtVersion.split('.').map(Number)
    const parts2 = targetVersion.split('.').map(Number)
    const maxLength = Math.max(parts1.length, parts2.length)

    for (let i = 0; i < maxLength; i++) {
      const num1 = parts1[i] || 0
      const num2 = parts2[i] || 0

      if (num1 < num2) {
          return -1
      } else if (num1 > num2) {
          return 1
      }
    }

    return 0
  },
  limitVersion(targetVersion) {
    const status = this.appVersionCompare(targetVersion)
    if (status < 0) {
      Dialog.alert({
        title: `该功能需要app版本不低于${targetVersion}，请完成更新后使用。`
      })

      return false
    }

    return true
  },
}